define(function(require) {
    var CC = require('CC');
    var BasicModel = require('models/app/BasicModel');
    var notificationModel = BasicModel.extend({
        urlRoot: CC.apiUrl + '/notifications',
    });
  
    return notificationModel;
});
